export enum OnboardingType {
  Sale = 'sale',
  Group = 'group',
  Membership = 'membership',
}
